import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { ConfigService } from './Common/Services/config.service';
import { tokenInterceptor } from './Common/token.interceptor';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fbf2f6',
      100: '#f5dce8',
      200: '#ebaccb',
      300: '#df78aa',
      400: '#c93d80',
      500: '#A80E4C', // <--- Our exact Primary Color
      600: '#8c0a3e',
      700: '#6f0630',
      800: '#540323',
      900: '#3b0218',
      950: '#21000b'
    }
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    MessageService,
    ConfirmationService,
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    // The modern way to handle APP_INITIALIZER logic
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return configService.loadConfig(); // Must return a Promise
    }),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.is-dark',
        },
      },
    }),
  ],
};
